import React from 'react';
export var CheckboxGroupContext = React.createContext({});
//# sourceMappingURL=checkbox-group-context.js.map